import React, { useState } from "react";
import PropTypes from "prop-types";
import { Grid, FormHelperText } from "@mui/material";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import FormField from "./FormField";
import { ranuButtonSx } from "./SectionCard";
import { confirmAction, getFieldError } from "./FormUtil";

const ReceiptForm = ({ devoteeId, devoteeAddressId, onSubmit, isLoading }) => {
  const [amount, setAmount] = useState("");
  const [touched, setTouched] = useState(false);

  // Real validation state: used to enable / disable the submit button
  const error = getFieldError("amount", amount, true);

  // What the user sees: an error only appears once the field has been blurred
  const visibleError = touched ? error : "";

  const handleSubmit = async () => {
    // Not valid yet: show the red error instead of submitting
    if (error) {
      setTouched(true);
      return;
    }

    const confirmed = await confirmAction({
      title: "Are you sure?",
      text: `Are you sure you want to proceed with the amount of ₹${Number(amount).toLocaleString(
        "en-IN"
      )}?`,
      confirmButtonText: "Send Receipt",
    });
    if (confirmed) {
      onSubmit({
        devotee_id: devoteeId,
        devotee_address_id: devoteeAddressId,
        amount: amount.toString(),
      });
    }
  };

  return (
    <Grid container spacing={2}>
      <FormField name="amount" required>
        <MDInput
          type="number"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          onBlur={() => setTouched(true)}
          error={!!visibleError}
          fullWidth
          placeholder="Enter amount"
        />
        {visibleError && <FormHelperText error>{visibleError}</FormHelperText>}
      </FormField>

      <Grid item xs={12}>
        <MDBox display="flex" justifyContent={{ xs: "center", sm: "flex-end" }}>
          <MDButton color="primary" onClick={handleSubmit} disabled={isLoading} sx={ranuButtonSx}>
            Send Receipt
          </MDButton>
        </MDBox>
      </Grid>
    </Grid>
  );
};

ReceiptForm.propTypes = {
  devoteeId: PropTypes.number.isRequired,
  devoteeAddressId: PropTypes.number.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default ReceiptForm;
